export default function selectJiraAreTypesLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].types.loading
}
